import { cohortTypeZodEnum } from '../../enum/cohort-type.zod-enum';
import { z } from 'zod';

export const cohortType = cohortTypeZodEnum();
export const participantToCohortTypeRow = z.array(z.string());
